import script from "./fieldTextarea.vue?vue&type=script&setup=true&lang=js"
export * from "./fieldTextarea.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__